import 'UI/Template'
import 'Dict/Data/DynRecords'
import './ViewEditForm'
import '../AttributeType'
import '../AttributeOption'
import '../Data/Objects'
import '../Data/Kinds'
import '../Security'
import { format, prepareControls } from '../AttributeHelper'

/** @namespace Accounting.UI */
NS('Accounting.UI');

/**
 * @class
 * @extends Accounting.UI.ViewEditForm
 */
Accounting.UI.ObjectForm = Class(Accounting.UI.ViewEditForm, /** @lends Accounting.UI.ObjectForm.prototype */{
    saveMethod: "saveDocument",
    formTemplate: "Accounting/ObjectForm/Form",
    itemTemplate: "Accounting/ObjectForm/Object",
    attributesTemplate: "Accounting/ObjectForm/Attributes",
    securityKey: "Accounting.Objects",
    sourceClass: "Accounting.Data.Objects",
    kindsSource: null,
    dictRecordsSource: null,

    titleField: null,
    titlePlaceHolder: 'Название',
    hideTitleAttribute: true,

	yearlist: (()=>{
		let years = [];
		for (let i = (new Date()).getFullYear()+1; i >= 2010; i--) {
			years.push({
				title: i,
				value: i
			});
		}
		return years
	})(),

    initialize() {
        this.ParentCall();

        this.kindsSource = new Accounting.Data.Kinds();
        this.dictRecordsSource = new Dict.Data.DynRecords();
        this.attributeHelper = { format }
    },
    canSave () {
        return Accounting.Security.checkItemAccess(this.item, this.securityKey, [Security.AccessMode.Insert, Security.AccessMode.Update], Security.AclAction.Write)
    },
    canRemove () {
        return Accounting.Security.checkItemAccess(this.item, this.securityKey, Security.AccessMode.Remove, Security.AclAction.Remove)
    },
    getTitle() {
        return (this.titleField&&this.item)?_.get(this, this.titleField):null;
    },
    findTitleField() {
        var self = this,
            setTitle = false;
        if (!('name' in this.item)) {
            this.titleField = null;
        }
        if (this.item.kind && this.item.kind.attributes) {
            _.forEach(this.item.kind.attributes, function (attribute) {
                if (attribute.options && attribute.options.isname && !setTitle) {
                    self.titleField = 'item.attributes.' + attribute.id;
                    self.titlePlaceHolder = attribute.name;
                    setTitle = true;
                }
            });
        }
    },
    destroy() {
        this.kindsSource = null;
        this.dictRecordsSource = null;

        return this.ParentCall();
    },

    render(options = {}) {
        this.findTitleField();
        this.Parent({
            ...options,
            silent: true
        });
        this.addControls(this.element);
        this.renderAttributes();

        _.defer(() => !options.silent && this.emit('ready'));

        return this;
    },

    validate () {
        if (!this.ParentCall()) {
            return false
        }
		var self = this
        let valid = true

        _(_.get(this.item, 'kind.attributes'))
            .filter(a => a.required)
            .forEach(attribute => {

				let dependent = _.get(_.find(self.item.kind.attributes, {id: parseInt(attribute.id)}), 'options.dependent');
				if (
					(dependent && dependent.active && (
						_.intersection(_.map(dependent.values, ({id}) => {return id;}),
							_.get(self.item.attributes, dependent.attribute+'.refs')).length
						|| (
							dependent.showOnNull &&
							!_.get(self.item.attributes, dependent.attribute+'.refs')
						)
					)) || !dependent ||
					(dependent && !dependent.active)) {
						const value = _.get(self.item, 'attributes.' + attribute.id)

						if (Util.isEmpty(value)) {
							this.$name('attribute_' + attribute.id).addClass('error')
							valid = false
						}
				}
            })
        return valid
    },
    /**
     * @return {Promise<Object>}
     */
    async save () {
        const item = await this.ParentCall()
        application.ui.notify(Util.String.coalesce(item.name, '#' + item.id) + " сохранен.")

        return item
    },
    renderAttributes() {
        const $attrs = this.$name("attributes");

        $attrs.find('control').each((i, elem) => this.unbindControl(elem));
        $attrs.empty();

        const controls = prepareControls(
            _.map(_.get(this.item, 'kind.attributes', []), (attribute) => {
                attribute = _.cloneDeep(attribute);
                attribute.value = _.get(this.item, `attributes.${attribute.id}`);

                attribute.options = _.assign({}, attribute.options, {
                    [ Accounting.AttributeOption.DictRecordsSource ]: 'dictRecordsSource',
                    [ Accounting.AttributeOption.ReferenceSource ]: 'source',
                    [ Accounting.AttributeOption.CreateReferenceHelper ]: 'createReferenceHelper',
                    [ Accounting.AttributeOption.AfterRenderCreateReferenceForm ]: 'afterRenderCreateReferenceForm',
                });

                return attribute;
            }), {new: this.item.id?false:true}
        );

        //noinspection ES6ModulesDependencies,NodeModulesDependencies
        $attrs.append(
            UI.Template.render(
                this.attributesTemplate,
                {
                    widget: this,
                    attributes: controls
                }
            )
        );

        this.addControls($attrs);
        if (this.isEditMode()) {
            this.showControls($attrs);
        } else {
			_.map(this.controls, function (control) {
				//const attribute =_.find(this.item.kind.attributes, {id: parseInt(control.control.id)});
				this.controlVisibilityUpdate(control);
			}.bind(this))
		}

        return this;
    },

    /**
     * References control helper
     *
     * @param {UI.Widget.Forms.Control.ReferenceSelect} control
     * @protected
     */
    async createReferenceHelper(control) {
        const { item } = await this.kindsSource.getDocument({
            id: control.filter.kindid
        });

        return Object.assign(control.ds.create(), {
            kindid: item.id,
            kindname: item.name,
            kind: item
        });
    },

    /**
     * @param {Accounting.UI.LightObjectForm} form
     * @protected
     */
    afterRenderCreateReferenceForm(form) {
        form.once("ready", () => form.edit());
    },

	onControlBind: function (control) {
		this.controlVisibilityUpdate (control);
	},

	onControlUpdate: function (control, value) {
    	_.map(this.item.kind.attributes, function (attribute, key) {
            //Костыль для установки multiple = true|false; в зависимости от выбранного значения пара
            //Какая задача, такое и решение
            if(attribute.alias === "par" && control.control.id == attribute.id) {
                let groupCultureSort = _.find(this.item.kind.attributes, {'alias': "fields_group_culture_sort"});
                if(groupCultureSort) {
                    let groupCultureSortControl = _.findIndex(this.controls, function (item) {
                        if(item.control.id == groupCultureSort.id) {
                            return item;
                        }
                    });
                    if(~groupCultureSortControl) {
                        if (control.value.refs[0] && (control.value.refs[0].key == 1)) {
                            if (this.controls[groupCultureSortControl].value.refs &&
                                this.controls[groupCultureSortControl].value.refs.length > 1)
                                this.controls[groupCultureSortControl].setValue([], true);
                            this.controls[groupCultureSortControl].setMultiple(false);
                        } else {
                            this.controls[groupCultureSortControl].setMultiple(this.controls[groupCultureSortControl].multiOption);
                        }
                        this.updateControl(this.controls);
                    }
                }
            }


			if (_.get(attribute, 'options.dependent.active')
				&& _.get(attribute, 'options.dependent.attribute') == control.control.id) {
				let depControl = _.find(this.controls,(c) => {
					return c.control.id == attribute.id
				})
				if (depControl)
					this.controlVisibilityUpdate(depControl);
			}
		}.bind(this));
	},

	controlVisibilityUpdate (control) {
		const attribute =_.find(this.item.kind.attributes, {id: parseInt(control.control.id)});
		if (this.checkVisibilityAttribute(attribute)) {
			control.$element.parent().show();
		} else {
			control.$element.parent().hide();
			control.setValue(null)
		}
	},

	checkVisibilityAttribute (attribute) {
		let dependent = _.get(attribute, 'options.dependent');
		if (dependent && dependent.active) {
			if (
				_.intersection(_.map(dependent.values, ({id}) => {return id;}),
					_.map(_.get(this.item.attributes, dependent.attribute+'.refs'), ({id}) => {return id;})).length
				|| (
					dependent.showOnNull &&
					(!_.get(this.item.attributes, dependent.attribute+'.refs') ||
						!_.get(this.item.attributes, dependent.attribute+'.refs').length)
				)
			) return true;
			else return false
		}
		return true;
	}

    // checkVisibilityAttribute (attribute) {
    //     let dependent = _.get(attribute, 'options.dependent');
    //     if (dependent && dependent.active) {
    //         if (
    //             _.intersection(_.map(dependent.values, ({id}) => {return id;}),
    //                 _.get(this.item.attributes, dependent.attribute+'.refs')).length
    //             || (
    //                 dependent.showOnNull &&
    //                 (!_.get(this.item.attributes, dependent.attribute+'.refs') ||
    //                     !_.get(this.item.attributes, dependent.attribute+'.refs').length)
    //             )
    //         ) return true;
    //         else return false
    //     }
    //     return true;
    // }
});
